import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
import { EntityService } from "./entity-service";

export class InventorySharedDataService {

    static $inject = ["$q", "entityService"];

    inventory: Models.IEntityCharDataPair;
    inventoryPromise: ng.IPromise<Models.IEntityCharDataPair>;

    inventoryStatus: Models.IEntityStatus;
    inventoryStatusPromise: ng.IPromise<Models.IEntityStatus>;

    constructor(private $q: ng.IQService, private entityService: EntityService) {
        this.inventory = null;
        this.inventoryStatus = null;
    }

    RefreshFiles(inventoryID: string): ng.IPromise<any> {
        if (this.inventoryPromise == null) {
            this.inventoryPromise = this.entityService.getEntity(inventoryID);
            this.inventoryPromise
                .then((result) => {
                    this.inventory = result;
                })
                .finally(() => {
                    this.inventoryPromise = null;
                });
        }
        return this.inventoryPromise || this.$q.when(this.inventory);
    }

    RefreshInventory(inventoryID: string): ng.IPromise<any> {
        if (this.inventoryPromise == null) {
            this.inventoryPromise = this.entityService.getEntity(inventoryID);
            this.inventoryPromise
                .then((result) => {
                    this.inventory = result;
                })
                .finally(() => {
                    this.inventoryPromise = null;
                });
        }
        return this.inventoryPromise || this.$q.when(this.inventory);
    }

    RefreshInventoryStatus(inventoryID: string): ng.IPromise<any> {
        if (this.inventoryStatusPromise == null) {
            this.inventoryStatusPromise = this.entityService.getEntityStatus(inventoryID);
            this.inventoryStatusPromise
                .then((result) => {
                    this.inventoryStatus = result;
                })
                .finally(() => {
                    this.inventoryStatusPromise = null;
                });
        }
        return this.inventoryStatusPromise || this.$q.when(this.inventoryStatus);
    }
}